import { prop, required, compose } from '@rxweb/reactive-form-validators';
import { Validators } from '@angular/forms';
import { CustomValidators } from '../../../../extensions/custom-validators';
import { RepresentativeType } from '../../../../models/enums/representative-type.enum';

export class BaseRepresentativesDataModel {
  constructor() {}

  @prop()
  id?: string;

  currentStep: string;

  @prop()
  personType: string;

  @prop()
  @compose({
    validators: [
      Validators.required,
      Validators.minLength(11),
      CustomValidators.isValidCNPJ()
    ]
  })
  socialNumber?: string;

  @required()
  name?: string;

  @prop()
  qualification?: string;

  @prop()
  @compose({ validators: [Validators.required] })
  nationalDocument?: string;

  @required()
  signatureType?: string;

  @prop()
  registerOriginType: string;

  @compose({ validators: [CustomValidators.isValidEmail()] })
  @required({
    conditionalExpression: (representative) =>
      representative.registerOriginType === 'Tokenizadora'
  })
  email: string;

  @prop()
  portalAccess: boolean;

  @prop()
  isMeetingRepresentant: boolean;

  @prop()
  @compose({ validators: [Validators.minLength(10)] })
  phone?: string;

  @prop()
  masterAccess?: boolean = false;

  @prop()
  representativeType?: RepresentativeType;

  @prop()
  @compose({ validators: [Validators.min(0), Validators.max(100)] })
  percentageShareholding?: number;
}
